var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-box"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"account-content"},[_c('router-view',{attrs:{"account":_vm.account,"context":_vm.context}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }